import React, { useEffect, useState } from "react";

import { MaskCEP } from "Utils/Masks";
import { validateCEP } from "Requests/cep";

import Input from "Components/Form/Input";
import PanelContent from "Components/Panels/PanelContent";

import { Field, useFormikContext } from "formik";
import { useQuery } from "react-query";
import { getCity } from "Requests/Units";

export function AddressInfo() {
  const {
    handleChange: handleChangeFormik,
    values,
    errors,
    setFieldValue,
    setFieldError,
  } = useFormikContext();

  const [cep, setCep] = useState("");

  const { data: cepData } = useQuery({
    queryKey: ["cep-validation", cep],
    queryFn: () => validateCEP(values.addresses.cep),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: !!cep,
  });

  const { data: cityData } = useQuery({
    queryKey: ["address-city", values.addresses.city],
    queryFn: () => getCity(values.addresses.city),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: !!values.addresses.city,
  });

  function sanitizeCep(value) {
    return value.replace(/\D/g, "");
  }

  async function handleCepChange({ target }) {
    const rawCep = sanitizeCep(target.value);
    setFieldValue("addresses.cep", rawCep);

    if (rawCep.length === 8) {
      setCep(rawCep);
    }
  }

  const handleChange = (e) => {
    handleChangeFormik(e);
    setFieldError(e.target.name, undefined);
  };

  const getCityIdFromOptions = (cityData, formValues) => {
    const currentCity = String(formValues.addresses.city || "")
      .trim()
      .toLowerCase();
    const currentState = String(formValues.addresses.state || "")
      .trim()
      .toLowerCase();

    const matchedCity = cityData.find((item) => {
      const city = String(item?.city || "")
        .trim()
        .toLowerCase();
      const state = String(item?.state || "")
        .trim()
        .toLowerCase();

      return city === currentCity && (!currentState || state === currentState);
    });

    if (matchedCity) return matchedCity.id;

    if (
      formValues.addresses.city_id &&
      cityData.some(
        (item) => String(item.id) === String(formValues.addresses.city_id)
      )
    ) {
      return formValues.addresses.city_id;
    }

    return cityData[0]?.id;
  };

  useEffect(() => {
    if (cepData) {
      setFieldValue("addresses.street", cepData.logradouro);
      setFieldValue("addresses.neighborhood", cepData.bairro);
      setFieldValue("addresses.city", cepData.localidade);
      setFieldValue("addresses.state", cepData.uf);
      //
      setFieldError("addresses.street", undefined);
      setFieldError("addresses.neighborhood", undefined);
      setFieldError("addresses.city", undefined);
      setFieldError("addresses.state", undefined);
      setFieldError("addresses.cep", undefined);
    }
  }, [cepData]);

  useEffect(() => {
    if (cityData?.length) {
      const nextCityId = getCityIdFromOptions(cityData, values);

      if (
        nextCityId &&
        String(values.addresses.city_id) !== String(nextCityId)
      ) {
        setFieldValue("addresses.city_id", nextCityId);
      }
    }
  }, [
    cityData,
    values.addresses.city,
    values.addresses.state,
    values.addresses.city_id,
    setFieldValue,
  ]);

  return (
    <PanelContent title="Informações de Endereço">
      <div className="row">
        <div className="md-6">
          <Field
            component={Input}
            label="Cep*"
            type="text"
            id="addresses.cep"
            placeholder={MaskCEP("00000000")}
            maxLength="9"
            value={MaskCEP(values.addresses.cep)}
            error={errors?.addresses?.cep}
            onChange={handleCepChange}
          />
        </div>
        <div className="md-6">
          <Field
            component={Input}
            label="Buscar Cidade*"
            placeholder="digite o nome da cidade"
            oSuggestionMessage="Nenhuma cidade encontrada!"
            id="addresses.city"
            value={values.addresses.city}
            error={errors?.addresses?.city}
            readOnly
          />
        </div>

        <div className="md-6">
          <Field
            component={Input}
            label="Bairro"
            type="text"
            id="addresses.neighborhood"
            maxLength={255}
            value={values.addresses.neighborhood}
            error={errors?.addresses?.neighborhood}
            readOnly
            onChange={handleChange}
          />
        </div>

        <div className="md-6">
          <Field
            component={Input}
            label="Rua*"
            type="text"
            id="addresses.street"
            maxLength={255}
            value={values.addresses.street}
            error={errors?.addresses?.street}
            readOnly
            onChange={handleChange}
          />
        </div>

        <div className="md-6">
          <Field
            component={Input}
            label="Complemento"
            type="text"
            id="addresses.complement"
            maxLength={145}
            value={values.addresses.complement}
            error={errors?.addresses?.complement}
            onChange={handleChange}
          />
        </div>
        <div className="md-6">
          <Field
            component={Input}
            label="Numero*"
            type="text"
            id="addresses.number"
            maxLength={5}
            value={values.addresses.number}
            error={errors?.addresses?.number}
            onChange={handleChange}
          />
        </div>
        <div className="md-6">
          <Field
            component={Input}
            label="longitude"
            type="text"
            id="addresses.longitude"
            maxLength={15}
            value={values.addresses.longitude}
            error={errors?.addresses?.longitude}
            readOnly
            onChange={handleChange}
          />
        </div>
        <div className="md-6">
          <Field
            component={Input}
            label="latitude"
            type="text"
            id="addresses.latitude"
            maxLength={15}
            value={values.addresses.latitude}
            error={errors?.addresses?.latitude}
            readOnly
            onChange={handleChange}
          />
        </div>
      </div>
    </PanelContent>
  );
}
